import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface RegulatorContextItem {
  label: string;
  code?: string | null;
  value?: string | null;
}

@Component({
  selector: 'regulator-context-box',
  imports: [],
  templateUrl: './regulator-context-box.component.html',
  styleUrl: './regulator-context-box.component.scss'
})
export class RegulatorContextBoxComponent {
  @Input() items: RegulatorContextItem[] = [];
  @Output() back = new EventEmitter<void>();
}
